import { environment } from '../environments/environment';

export const GlobalConstants = Object.freeze({
  version: '1.0',
  production: environment.production, // true or false depending on the build configuration
  // ng build --configuration=production
  urlServer: environment.urlServer,
  urlWeb: environment.urlWeb,
  urlBase: environment.urlBase,
  secret: 'tamqlctmemdmc',
  siteKey: '6Ley2qArAAAAAL7_LKUCnCfVMsTuZtRvcxgHf4vA', // https://www.google.com/recaptcha/
  maxfotos: 30
});